<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToTableHead'
});
</script>
<template>
	<thead ref="row" class="to-table-head">
		<tr class="to-table-head-row">
			<template v-for="column in props.data">
				<th v-if="column.type === 'check'" :key="column.prop + 'check'" class="to-table-th is-check">
					<ToCheckbox :model-value="checkedAll" @change="change"></ToCheckbox>
				</th>
				<th v-else-if="column._show !== false" :key="column.prop" class="to-table-th" :class="setThClass(column).value" @click="sortClick(column)">
					<span>{{ column.label }}</span>
					<span v-if="column.sortable" class="to-table-sorticon">
						<span class="to-table-sorticon-item ascending"></span>
						<span class="to-table-sorticon-item descending"></span>
					</span>
				</th>
			</template>
		</tr>
	</thead>
</template>
<script setup lang="ts">
import { computed, inject, onMounted, ref, watch } from 'vue'
import { TableProvideType } from './table.vue'

const tableRef: TableProvideType = inject('TableRef')
const emit = defineEmits(['change'])
interface Props {
	data?: { prop?: string; label?: string; type?: string; toggler?: boolean; _show: boolean; thWrap?: boolean; sortable?: boolean; sortType?: boolean }[]
	checkedAll?: boolean
}
const props = withDefaults(defineProps<Props>(), {
	data: () => [],
	checkedAll: false
})

const row = ref(null)
const sortSet = ref({})

watch(
	() => props.data,
	val => {
		val.forEach(item => {
			if (item.sortable) {
				sortSet.value[item.prop] = sortSet.value[item.prop] || ''
			}
		})
	},
	{ deep: true }
)

onMounted(() => {
	props.data.forEach(item => {
		if (item.sortable) {
			sortSet.value[item.prop] = sortSet.value[item.prop] || ''
		}
	})
})

const sortClick = column => {
	if (!column.sortable) return false
	if (sortSet.value[column.prop] === 'asc') {
		sortSet.value[column.prop] = 'desc'
	} else if (sortSet.value[column.prop] === 'desc') {
		sortSet.value[column.prop] = ''
	} else {
		sortSet.value[column.prop] = 'asc'
	}
	tableRef.handleTheadCellClick(column, sortSet.value[column.prop])
}
const setThClass = column => {
	return computed(() => {
		const classes: string[] = []
		if (column.thWrap) {
			classes.push('is-wrap')
		} else if (column.thWrap === false) {
			classes.push('is-nowrap')
		}
		if (sortSet.value[column.prop]) {
			classes.push(`type-${sortSet.value[column.prop]}`)
		}
		return classes
	})
}
function change(checked) {
	emit('change', checked)
}

defineExpose({
	row
})
</script>
